import {BACKEND_API} from '../middleware/backend'

export const EVENTS_REQUEST = 'EVENTS_REQUEST';
export const EVENTS_SUCCESS = 'EVENTS_SUCCESS';
export const EVENTS_FAILURE = 'EVENTS_FAILURE';
export const EVENTS_COUNT_REQUEST = 'EVENTS_COUNT_REQUEST';
export const EVENTS_COUNT_SUCCESS = 'EVENTS_COUNT_SUCCESS';
export const EVENTS_COUNT_FAILURE = 'EVENTS_COUNT_FAILURE';
export const EVENT_REQUEST = 'EVENT_REQUEST';
export const EVENT_SUCCESS = 'EVENT_SUCCESS';
export const EVENT_FAILURE = 'EVENT_FAILURE';
export const EVENT_SAVE_REQUEST = 'EVENT_SAVE_REQUEST';
export const EVENT_SAVE_SUCCESS = 'EVENT_SAVE_SUCCESS';
export const EVENT_SAVE_FAILURE = 'EVENT_SAVE_FAILURE';
export const EVENT_INFO_REQUEST = 'EVENT_INFO_REQUEST';
export const EVENT_INFO_SUCCESS = 'EVENT_INFO_SUCCESS';
export const EVENT_INFO_FAILURE = 'EVENT_INFO_FAILURE';

export const loadEvents = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [EVENTS_REQUEST, EVENTS_SUCCESS, EVENTS_FAILURE],
			endpoint: "event/list",
			filter: filter
		}
	})
};

export const countEvents = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [EVENTS_COUNT_REQUEST, EVENTS_COUNT_SUCCESS, EVENTS_COUNT_FAILURE],
			endpoint: "event/count",
			filter: filter
		}
	})
};

export const loadEvent = (id) => (dispatch, getState) => {
	return dispatch({
		id: id,
		[BACKEND_API]: {
			types: [EVENT_REQUEST, EVENT_SUCCESS, EVENT_FAILURE],
			endpoint: `event/${id}`,
		}
	})
};

export const saveEvent = (event) => (dispatch, getState) => {
	return dispatch({
		id: event.eventId,
		event: event,
		[BACKEND_API]: {
			types: [EVENT_SAVE_REQUEST, EVENT_SAVE_SUCCESS, EVENT_SAVE_FAILURE],
			endpoint: 'event',
			body: event,
			silent: true
		}
	})
};

export const loadEventInfo = (id) => (dispatch, getState) => {
	return dispatch({
		id: id,
		[BACKEND_API]: {
			types: [EVENT_INFO_REQUEST, EVENT_INFO_SUCCESS, EVENT_INFO_FAILURE],
			endpoint: `event/info/${id}`,
		}
	})
};



// WEBPACK FOOTER //
// ./src/actions/events.js